<template>
  <!--  <div class="row justify-content-end mb-5 no-print border border-danger">-->
  <form class="form-inline justify-content-end mb-5 no-print">
    <operator-selector v-if="byOperator"/>
    <detailed-report-period v-if="!toDateOnly"/>
    <report-to-date v-else/>
    <el-tooltip :content="$t('generic.ignoreReportingCacheTooltip')"
                effect="light" :open-delay="300" placement="bottom">
      <base-button icon type="warning" size="md" v-if="$auth.isAdmin() && $route.meta.cacheable === true"
                   :disabled="loading"
                   @click="doReloadReportWithoutCache()">
        <i class="tim-icons icon-refresh-01"></i>
      </base-button>
    </el-tooltip>
    <base-button type="primary"
                 :loading="loading"
                 @click="doReloadReport()">
      {{ $t('generic.makeReportBtnLbl') }}
      <i class="tim-icons icon-triangle-right-17"/>
    </base-button>
  </form>
</template>
<script>
import {mapState} from "vuex";
import DetailedReportPeriod from 'src/components/DetailedReportPeriod/DetailedReportPeriod';
import ReportToDate from 'src/components/ReportToDate/ReportToDate';
import OperatorSelector from './OperatorSelector';

export default {
  name: 'report-filter',
  components: {
    DetailedReportPeriod,
    ReportToDate,
    OperatorSelector
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      description: 'Flag indicating report is loading.'
    },
    byOperator: {
      type: Boolean,
      required: false,
      description: 'Flag indicating that filtering by operator must be show.'
    },
    reloadReport: {
      type: Function,
      required: true,
      description: 'Callback function.'
    },
    toDateOnly: {
      type: Boolean,
      required: false,
      description: 'Flag indicating that filtering time should be single date instead of range.'
    },
  },
  data() {
    return {
      reportingRequestPeriod: null, // Will be assigned on the first request.
    };
  },
  computed: {
    ...mapState({
      selectedReportOperator: state => state.profile.selectedReportOperator,
      selectedReportPeriod: state => state.profile.selectedReportPeriod,
      selectedReportToDate: state => state.profile.selectedReportToDate,
    }),
  },
  methods: {
    doReloadReportWithoutCache() {
      let operatorId = ''
      if (this.selectedReportOperator) {
        operatorId = this.selectedReportOperator.id;
      }
      this.reloadReport({
        period: this.selectedReportPeriod,
        toDate: this.selectedReportToDate,
        operatorId: operatorId,
        ignoreCache: true,
      });
    },
    doReloadReport() {
      let operatorId = ''
      if (this.selectedReportOperator) {
        operatorId = this.selectedReportOperator.id;
      }
      this.reloadReport({
        period: this.selectedReportPeriod,
        toDate: this.selectedReportToDate,
        operatorId: operatorId,
      });
    },
  }
};
</script>
